<template>
	<div class="header">
		<div class="left">
			<span>机台：{{ jt_name }}</span>
			<span>质检员：</span>
			<span>批次：{{ batch_name }}</span>
			<span>产品名称：{{ product_name }}</span>
		</div>

		<div class="right">
			<!--版面-->
			<div class="left" style="margin-right:10px;margin-top: -3px;">
				<button :class="{ sufaceBtn: true, active: selected_side_index == item.value }" v-for="(item, index) in surfacelist" :key="index" @click="changeModelSide(item.value)">{{ item.text }}</button>
			</div>
			<div class="right">
				<label for="topbar_show_rule_bar">
					<input type="checkbox" id="topbar_show_rule_bar" v-model="showRuleBar" />
					显示标尺
				</label>
				<label for="topbar_show_defect_point">
					<input type="checkbox" id="topbar_show_defect_point" v-model="showDefectPoints" />
					缺陷点
				</label>
			</div>
		</div>
		<div style="clear:both;"></div>
	</div>
</template>

<script>
	import { productRequest } from '@/network/requests/product'
	export default {
		data() {
			return {
				showDefectPoints: false,
				showRuleBar: true,
				product_name: '',
				selected_side_index: 0,
			}
		},
		props: {
			jt_name: {
				type: String,
			},
			batch_name: {
				type: String,
			},
			product_id: {
				type: String,
			},
			modelSides: {
				type: Array,
			},
			sideIndex: {
				type: Number,
			},
		},
		computed: {
			surfacelist() {
				var list = []
				if (this.modelSides) {
					this.modelSides.forEach((v, i) => {
						console.log('modelsides', v)
						list.push({
							value: v.side_index,
							text: v.name,
						})
					})
				}
				return list.sort((a, b) => {
					return a.value - b.value
				})
			},
		},
		watch: {
			sideIndex(val) {
				this.selected_side_index = val
			},
			showDefectPoints(val) {
				if (val) {
					this.$emit('showDefectPoints')
				} else {
					this.$emit('hideDefectPoints')
				}
			},
			showRuleBar(val) {
				if (val) {
					this.$emit('showRuleBar')
				} else {
					this.$emit('hideRuleBar')
				}
			},
			product_id(val) {
				if (val) {
					productRequest.getDocumentById(val).then(res => {
						console.log('产品信息', res)
						this.product_name = res.data.name
					})
				}
			},
		},
		methods: {
			/**
			 * 切换版面。
			 */
			changeModelSide(side_index) {
				this.selected_side_index = side_index
				this.$emit('changeModeSideIndex', side_index)
			},
		},
		created() {},
	}
</script>

<style scoped>
	.left {
		float: left;
	}

	.right {
		float: right;
	}

	.header {
		background-color: #00000030;
		height: 25px;
		padding: 5px 10px 0 10px;
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		z-index: 9;
	}

	.header span {
		margin-right: 10px;
		font-size: 12px;
	}

	.sufaceBtn {
		font-size: 12px;
		height: 25px;
		margin-left: 5px;
		font-family: inherit;
		border: none;
		background-color: #eee;
		padding: 0 10px;
	}

	.sufaceBtn.active {
		color: #0008ff;
		font-weight: bold;
	}
</style>
